exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gamehkys {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: #000;\n}\n.gamehkys .closeBtn {\n  position: absolute;\n  right: 0rem;\n  top: 0rem;\n  z-index: 99;\n  padding: 0.2rem;\n}\n.gamehkys .closeBtn img {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n.gamehkys .app-games-iframe {\n  width: 100%;\n  height: 95%;\n  border: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/app/game-hkys/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/app/game-hkys/index.less
// module chunks = 0